/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/canvas/:workflow_id/content_optimization_launch_limit" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdCanvasWorkflowIdContentOptimizationLaunchLimit } from "./constants";
import type {
  GetEngagementAppGroupIdCanvasWorkflowIdContentOptimizationLaunchLimitProps,
  GetEngagementAppGroupIdCanvasWorkflowIdContentOptimizationLaunchLimitResult,
} from "./types";
import { isGetEngagementAppGroupIdCanvasWorkflowIdContentOptimizationLaunchLimitResult } from "./validators";

export const getEngagementAppGroupIdCanvasWorkflowIdContentOptimizationLaunchLimit = reactQueryFetcherAdapter(
  engagementAppGroupIdCanvasWorkflowIdContentOptimizationLaunchLimit,
  (
    signal: AbortSignal,
    {
      appGroupId,
      workflowId,
      viewActiveCanvas,
    }: GetEngagementAppGroupIdCanvasWorkflowIdContentOptimizationLaunchLimitProps
  ): Promise<GetEngagementAppGroupIdCanvasWorkflowIdContentOptimizationLaunchLimitResult> => {
    return fetch(
      `/engagement/${appGroupId}/canvas/${workflowId}/content_optimization_launch_limit`,
      "GET",
      { view_active_canvas: viewActiveCanvas },
      { signal }
    );
  },
  isGetEngagementAppGroupIdCanvasWorkflowIdContentOptimizationLaunchLimitResult
);
